'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Schema;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _config = require('config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Schema(props) {
  return _react2.default.createElement('script', {
    type: 'application/ld+json',
    dangerouslySetInnerHTML: { __html: JSON.stringify({
        '@context': 'http://schema.org',
        '@type': 'Organization',
        'address': {
          '@type': 'PostalAddress',
          'addressLocality': _config.config.address_city,
          'addressRegion': _config.config.address_state,
          'postalCode': _config.config.address_zipcode,
          'streetAddress': _config.config.address_street,
          'addressCountry': _config.config.address_contry,
          'areaServed': _config.config.address_area,
          'telephone': _config.config.phone_number
        },
        'email': _config.config.email,
        'logo': _config.config.logo,
        'name': _config.config.name,
        'legalName': _config.config.legal_name,
        'url': _config.config.url
      }) }
  });
}
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9pc29tb3JwaGljL0NvbXBvbmVudHMvU2NoZW1hLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O2tCQUd3QixNOztBQUh4Qjs7OztBQUNBOzs7O0FBRWUsU0FBUyxNQUFULENBQWdCLEtBQWhCLEVBQXVCO0FBQ3BDLFNBQ0U7QUFDRSxVQUFLLHFCQURQO0FBRUUsNkJBQXlCLEVBQUMsUUFBUSxLQUFLLFNBQUwsQ0FBZTtBQUMvQyxvQkFBWSxtQkFEbUM7QUFFL0MsaUJBQVMsY0FGc0M7QUFHL0MsbUJBQVc7QUFDVCxtQkFBUyxlQURBO0FBRVQsNkJBQW1CLGVBQU8sWUFGakI7QUFHVCwyQkFBaUIsZUFBTyxhQUhmO0FBSVQsd0JBQWMsZUFBTyxlQUpaO0FBS1QsMkJBQWlCLGVBQU8sY0FMZjtBQU1ULDRCQUFrQixlQUFPLGNBTmhCO0FBT1Qsd0JBQWMsZUFBTyxZQVBaO0FBUVQsdUJBQWEsZUFBTztBQVJYLFNBSG9DO0FBYS9DLGlCQUFTLGVBQU8sS0FiK0I7QUFjL0MsZ0JBQVEsZUFBTyxJQWRnQztBQWUvQyxnQkFBUSxlQUFPLElBZmdDO0FBZ0IvQyxxQkFBYSxlQUFPLFVBaEIyQjtBQWlCL0MsZUFBTyxlQUFPO0FBakJpQyxPQUFmLENBQVQ7QUFGM0IsSUFERjtBQXdCRCIsImZpbGUiOiJTY2hlbWEuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgeyBjb25maWcgfSBmcm9tICdjb25maWcnXG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIFNjaGVtYShwcm9wcykge1xuICByZXR1cm4gKFxuICAgIDxzY3JpcHRcbiAgICAgIHR5cGU9J2FwcGxpY2F0aW9uL2xkK2pzb24nXG4gICAgICBkYW5nZXJvdXNseVNldElubmVySFRNTD17e19faHRtbDogSlNPTi5zdHJpbmdpZnkoe1xuICAgICAgICAnQGNvbnRleHQnOiAnaHR0cDovL3NjaGVtYS5vcmcnLFxuICAgICAgICAnQHR5cGUnOiAnT3JnYW5pemF0aW9uJyxcbiAgICAgICAgJ2FkZHJlc3MnOiB7XG4gICAgICAgICAgJ0B0eXBlJzogJ1Bvc3RhbEFkZHJlc3MnLFxuICAgICAgICAgICdhZGRyZXNzTG9jYWxpdHknOiBjb25maWcuYWRkcmVzc19jaXR5LFxuICAgICAgICAgICdhZGRyZXNzUmVnaW9uJzogY29uZmlnLmFkZHJlc3Nfc3RhdGUsXG4gICAgICAgICAgJ3Bvc3RhbENvZGUnOiBjb25maWcuYWRkcmVzc196aXBjb2RlLFxuICAgICAgICAgICdzdHJlZXRBZGRyZXNzJzogY29uZmlnLmFkZHJlc3Nfc3RyZWV0LFxuICAgICAgICAgICdhZGRyZXNzQ291bnRyeSc6IGNvbmZpZy5hZGRyZXNzX2NvbnRyeSxcbiAgICAgICAgICAnYXJlYVNlcnZlZCc6IGNvbmZpZy5hZGRyZXNzX2FyZWEsXG4gICAgICAgICAgJ3RlbGVwaG9uZSc6IGNvbmZpZy5waG9uZV9udW1iZXIsXG4gICAgICAgIH0sXG4gICAgICAgICdlbWFpbCc6IGNvbmZpZy5lbWFpbCxcbiAgICAgICAgJ2xvZ28nOiBjb25maWcubG9nbyxcbiAgICAgICAgJ25hbWUnOiBjb25maWcubmFtZSxcbiAgICAgICAgJ2xlZ2FsTmFtZSc6IGNvbmZpZy5sZWdhbF9uYW1lLFxuICAgICAgICAndXJsJzogY29uZmlnLnVybCxcbiAgICAgIH0pfX1cbiAgICAvPlxuICApXG59XG4iXX0=


/*****************
 ** WEBPACK FOOTER
 ** ../~/gatsby-asdf/dist/isomorphic/components/Schema.js
 ** module id = 391
 ** module chunks = 0
 **/